import React, {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router-dom';

import {setSearchId} from 'src/components/criteria-strip/services/criteria-strip-slice';
import {generateSearchId} from 'src/utils/generate-search-id';

export const Home = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const searchId = generateSearchId();

        dispatch(setSearchId(searchId));
        navigate(`/search-criteria/${searchId}/accounts`, {replace: true});
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return <div/>;
};
